export enum PermissionType {
    Unlock = 1,
    Authorize,
    Software
}